<header class="header header--fixed">
  <div class="container-fluid">
    <div class="header__content">
      <nav class="navbar bg-body-dark navbar-expand-xl">
        <a href="/" class="header__logo">
          <img [src]="
              theme == 'dark'
                ? 'assets/images/new-logo.svg'
                : 'assets/images/new-logo.svg'
            " alt="" class="img-fluid" />

        </a>
        <div class="dash_top_header">
          <button class="header__btn" type="button">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <app-theme class="dashboard_theme"></app-theme>
          <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
            <li class="nav-item">
              <span class="withdraw_btn cursor-pointer" (click)="switchNearMalls()">Utility Services</span>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/launchpad" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Launchpad</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="/subscriptionpage" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Subscription</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/market-inner" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Market</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/fee-inner" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Fees</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/spot" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Spot</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" routerLink="/eoptions-trade" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Options</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link d-flex" routerLink="/notification" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                Notification
                <span class="notify_count mx-1" *ngIf="unread_count > 0">{{
                  unread_count
                  }}</span>
              </a>
            </li>
            <li class="nav-item mx-auto">
              <button class="btn startButton" data-bs-toggle="modal" data-bs-target="#new_bot_modal">
                <img [src]="
                    theme == 'dark'
                      ? 'assets/images/startboticon.svg'
                      : 'assets/images/startboticon.svg'
                  " alt="Bot Status" class="img-fluid" />
                Start New Bot
              </button>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/buy-crypto" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Buy Crypto</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/commission-transaction" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">Earn</a>
            </li>
            <li>
              <app-theme></app-theme>
            </li>
            <!-- <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Dropdown
              </a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li>
                  <a class="dropdown-item" href="#">Something else here</a>
                </li>
              </ul>
            </li> -->
          </ul>
        </div>
      </nav>
    </div>
  </div>
</header>
<div class="modal fade primary_modal" id="new_bot_modal" tabindex="-1" aria-labelledby="new_bot_modalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="new_bot_modalLabel">Start new bot</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="new_bot_panel">
          <a href="/dcabot">
            <div class="new_bot_panel_content">
              <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium qKdO78InOm9rrEHhxNsG css-vubbuv" focusable="false"
                aria-hidden="true" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="10" fill="#28BA74"></rect>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M24 28.8c-.66 0-1.2-.54-1.2-1.2V8.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v19.2c0 .66-.54 1.2-1.2 1.2Zm-13.2-1.2v-4.8c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v4.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2Zm6-12v12c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2v-12c0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2Z"
                  fill="#fff"></path>
              </svg>
              <h4>DCA Bot</h4>
            </div>
            <p>
              The Dollar-cost Averaging bot multiplies your gains and reduces
              risks in volatile markets.
            </p>
          </a>
          <a href="/gridbot">
            <div class="new_bot_panel_content">
              <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium qKdO78InOm9rrEHhxNsG css-vubbuv" focusable="false"
                aria-hidden="true" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="10" fill="#6552EC"></rect>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M27.6 8.1H8.4c-.66 0-1.2.54-1.2 1.2v2.4c0 .66.54 1.2 1.2 1.2h19.2c.66 0 1.2-.54 1.2-1.2V9.3c0-.66-.54-1.2-1.2-1.2ZM8.4 15.3h19.2c.66 0 1.2.54 1.2 1.2v1.2c0 .66-.54 1.2-1.2 1.2H8.4c-.66 0-1.2-.54-1.2-1.2v-1.2c0-.66.54-1.2 1.2-1.2Zm0 6h19.2c.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2H8.4c-.66 0-1.2-.54-1.2-1.2 0-.66.54-1.2 1.2-1.2Zm-.6 4.8h20.4c.336 0 .6.264.6.6 0 .336-.264.6-.6.6H7.8a.594.594 0 0 1-.6-.6c0-.336.264-.6.6-.6Z"
                  fill="#fff"></path>
              </svg>
              <h4>GRID Bot</h4>
            </div>
            <p>
              The proven grid strategy bot maximizes your returns on the
              slightest price changes.
            </p>
          </a>





          <!-- <div style="font-family: 'Segoe UI', sans-serif; color: #fff; max-width: 600px; margin: 0 auto;">

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;"> -->

          <!-- <a href="/adminBot"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(40, 186, 116, 0.3); border-left: 4px solid #28BA74; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #28BA74;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                    <polyline points="17 6 23 6 23 12"></polyline>
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">VWAP Upside</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Standard volume trend.</p>
              </a> -->

          <!-- <a href="/adminTradeBotGuru"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(171, 71, 188, 0.3); border-left: 4px solid #AB47BC; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #AB47BC;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <polygon
                      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                    </polygon>
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Guru Bot</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Expert logic system.</p>
              </a> -->

          <!-- <a href="/adminTradeUpsideHanuman"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(40, 186, 116, 0.3); border-left: 4px solid #28BA74; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #28BA74;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Hanuman Up</span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Aggressive buying.</p>
              </a> -->

          <!-- <a href="/hanumanBot"
                style="text-decoration: none; background: rgba(255,255,255,0.05); padding: 15px; border-radius: 8px; border: 1px solid rgba(239, 83, 80, 0.3); border-left: 4px solid #EF5350; display: flex; flex-direction: column; justify-content: center;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <svg style="width: 20px; height: 20px; color: #EF5350;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M12 5v14M19 12l-7 7-7-7" />
                  </svg>
                  <span style="margin-left: 8px; font-weight: 600; font-size: 14px; color: #fff;">Hanuman </span>
                </div>
                <p style="margin: 0; font-size: 11px; color: #aaa;">Short selling strategy.</p>
              </a>

            </div>
          </div> -->



        </div>
      </div>
    </div>
  </div>
</div>